import axios from '../../axios'

/*
 * 文章数据接口
 */

// 首页链接配置
export const liveApi = (data) => {
    return axios({
        url: '/api/data/wish/live',
        method: data.method || 'GET',
        data: data.data
    })
}

// 开始推流
export const startApi = (data) => {
    return axios({
        url: '/api/data/wish/live/start',
        method: 'POST',
        data
    })
}

// 结束推流
export const stopApi = (data) => {
    return axios({
        url: '/api/data/wish/live/stop',
        method: 'POST',
        data
    })
}

// 生成回放
export const recordApi = (data) => {
    return axios({
        url: '/api/data/wish/live/record',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/wish/live.js